module.exports = __webpack_public_path__ + "img/HINDU DIWALI LIME.3ef2600.svg";